<app-form-schema-renderer *ngIf="resolvedSchema && data"
								[property]="[]" [schema]="resolvedSchema" [data]="data" [readonly]="false"
								(emitFormSubmit)="createNewUser($event)" [formID]="userFormID"
								(emitFormValid)="setSubmitActive($event)">
</app-form-schema-renderer>
<div nz-row [nzJustify]="'space-between'">
	<div nz-col>
		<div nz-row [nzGutter]="[16, 6]">
			<div nz-col>
				<app-splitbutton [elements]="[userCancelSplitButton]"></app-splitbutton>
			</div>
		</div>
	</div>
	<div nz-col>
		<div nz-row [nzJustify]="'end'" [nzGutter]="[16, 6]">
			<div nz-col>
				<app-splitbutton *ngIf="resolvedSchema && data"
								[elements]="[userAddSplitButton]"
				>
				</app-splitbutton>
			</div>
		</div>
	</div>
</div>
